import React from 'react'
import Label from "components/general/Label"
import { ColumnStartOrder, ColumnBib, ColumnName, ColumnNoc, ColumnExpander } from "components/common/TableColumns"
import { ColumnIntermediateRank } from "components/common/TableColumnsIntermediates"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons"
import { findArray } from 'helpers/utils'
import Movement from "components/presentation/Movement"

/* Current first athlete*/
function getCurrent(props) {
    return (
        props.currentSplit === '999' ? props.finalSplit : props.currentSplit
    )
}

/* Current by  athlete*/
function getCurrentAth(props) {
    const max = props?.extendedResults?.reduce((prev, current) => (Number(prev.er_pos) > Number(current.er_pos)) ? prev : current)
    return (
        max?.er_pos
    )
}

function getMove(props) {
    if(props?.extendedResults){
        let resp = findArray(props.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [getCurrent(props)] }).er_move
        return (
            resp
        )
    }
    else{
        return '-'
    }
}


export function ColumnWarnings({
    className = 'text-end',
    headerClassName = 'text-end w-5',
    label = ''
    }) {
    return (
        {
            Header: <Label data={label} />,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: true,
            id: 'WarningsWalk',
            Cell: (props) => {
                let warnings = props.cell.row?.original?.extendedResults && props.cell.row?.original?.extendedResults.filter(er => er.er_code === 'WARNINGS')
                return(
                    <>{
                    warnings && warnings.map((warn) =>{
                        return warn.er_value
                    })
                }</>
                )
            }
        }
    )
}


export function ColumnMove() {
    return (
        {   id: 'Move',
            Header: () => (<><FontAwesomeIcon icon={faArrowUp} /> <FontAwesomeIcon icon={faArrowDown} /></>),
            accessor: (props) => {
                const moveCurrent = props?.extendedResultsCurrent && props?.extendedResultsCurrent[0] ? props?.extendedResultsCurrent[0]?.er_move : getMove(props)
                return (<Movement move={moveCurrent} />)
            },
            className: 'text-end w-5',
            headerClassName: 'text-end ',
            disableSortBy: true,
            
            
        }
    )
}

export function ColumnIntermediate({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-5',
    label = 'HeaderIntermediate',
    config = ''
}) {

    return (
        {
            Header: <Label data={label} />,
            //accessor: (props) => (findArray(config, { ei_code: ['INTERMEDIATE'], ei_pos: [getCurrentAth(props)] }).ei_value),
            accessor: (props) => getCurrentAth(props),
            sortType: "absoluteOrderNumber",
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Intermediate',
            Cell: (props) => {
                let val = findArray(config, { ei_code: ['INTERMEDIATE'], ei_pos: [getCurrentAth(props.cell.row.original)] }).ei_value
                return (
                    (props.cell.row.original.resultType !== 'IRM')
                        ? isNaN(Number(val)) ? val : val + 'km'
                        : ''
                )
            },


        }
    )
}

export function ColumnIntermediateTime({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderTime',
    config = ''
}) {

    return (
        {
            Header: <Label data={label} />,
            //accessor: (props) => (findArray(config, { ei_code: ['INTERMEDIATE'], ei_pos: [getCurrentAth(props)] }).ei_value),
            accessor: (props) => getCurrentAth(props),
            sortType: "absoluteOrderNumber",
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'IntermediateTime',
            Cell: (props) => {
                let val = findArray(props.cell.row.original.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [getCurrentAth(props.cell.row.original)] }).er_value
                return (
                    (props.cell.row.original.resultType !== 'IRM')
                        ? val
                        : props.cell.row.original.resultIrm
                )

            },


        }
    )
}

function ColumnIntermediateDiff({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderTimeBehind',
    config = ''
}) {

    return (
        {
            Header: <Label data={label} />,
            //accessor: (props) => (findArray(config, { ei_code: ['INTERMEDIATE'], ei_pos: [getCurrentAth(props)] }).ei_value),
            accessor: (props) => getCurrentAth(props),
            sortType: "absoluteOrderNumber",
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'IntermediateDiff',
            Cell: (props) => {
                let val = findArray(props.cell.row.original.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [getCurrentAth(props.cell.row.original)] }).er_diff
                return (
                    (props.cell.row.original.resultType !== 'IRM')
                        ? val
                        : ''
                )

            },


        }
    )
}

export function TableColumns(columnsAdded) {

    return (
        [
            ColumnIntermediateRank({}),
            ColumnMove(),
            ColumnStartOrder({ label: 'HeaderOrder' }),
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnIntermediate({ config: columnsAdded }),
            ColumnIntermediateTime({}),
            ColumnIntermediateDiff({}),
            ColumnWarnings({}),
            ColumnExpander({ type: 'extendedResults' })
        ]
    )
}

export default TableColumns
